import {v3} from "oc-threejs/short3";

export default class Preisberechnung {

    currentSchrankIndex;
    currrentElementIndex;

    constructor(arrangement) {
        this.arrangement = arrangement;
        this.partsList = this.arrangement.partsList;
    }

    getPreis(): number {
        return this._getPreisVonArrangement();
    }

    calcAssemblyPrice(priceType = 'customer') {
        let costs = 0;
        return costs;
    }

    _getPreisVonServer(): number {
        return 0;
    }

    _getPreisVonArrangement(): number {
        this._updateLocalPartsList();
        return this._getPreisFromPartsList();
    }

    _getPreisFromPartsList(): number {
        let preis = 0;
        preis += this.partsList.model.preis;
        const sumDeep = part => {
            if (part.preis!=null && !Number.isNaN(part.preis)) {
                preis += part.preis;
            }
            if (part.parts) {
                part.parts.forEach(sumDeep);
            }
        };
        this.partsList.schraenke.forEach(sumDeep);
        return preis / 100;
    }

    _updateLocalPartsList() {
        this.partsList.schraenke.length = 0;
        this.arrangement.schraenke.forEach((schrank, index) => {
            this.currentSchrankIndex = index;
            this.partsList.schraenke.push(this._calculateLocalSchrankPreis(schrank));
        });
        this.partsList.model = this.calculateLocalModelPrice();

    }

    _createPartsListEntry(item, priceData, product = null) {
        //materialInfo: {Artikelnummer: userData.material, Name:dekor.Name, qmPreis: dekor.qmPreis},

        const usedProduct = product ? product : item.product;
        const entry = {
            groesse: this._getConfigSize(item),
            priceData: priceData,
            preis: priceData.preis,
            schrankIndex: this.currentSchrankIndex,
            elementIndex: this.currrentElementIndex
        };
        ['Name', 'Anzeigereihenfolge', 'Anzeigename', 'Artikelnummer', 'Beschreibung', 'type'].forEach(key => {
            entry[key] = usedProduct[key];
        });

        if (item.materialArtikelnummer) {
            const materialData = APP.findProduct(item.materialArtikelnummer);
            entry.materialInfo = {
                Artikelnummer: item.materialArtikelnummer,
                Name: materialData.Name,
                qmGewicht: materialData.qmGewicht,
                qmPreis: materialData.qmPreis
            };
        }
        return entry;
    }

    _createGriffEntry(griff, griffArtikelnummer) {

        let product = APP.findProduct(this.arrangement.griffArtikelnummer);
        if (griffArtikelnummer) {
            product = APP.findProduct(griffArtikelnummer);
        }
        return this._createPartsListEntry(griff, this._getProduktPreis(product, griff), product);
    }

    _calculateLocalSchrankPreis(schrank) {
        let result = {};
        result = this.addBretterOfSchrank(schrank, result);
        const schrankIndex = this.arrangement.schraenke.indexOf(schrank);
        const tuerenObject = {
            name: 'Türen',
            parts: []
        };
        const griffeObject = {
            name: 'Griffe',
            parts: []
        };
        const einbautenObject = {
            name: 'Einbauten',
            parts: []
        };
        schrank.elements.forEach((element, elementIndex) => {
            this.currrentElementIndex = elementIndex;
            element.interieurs.forEach((interieur) => {
                if (interieur.product.type === 'Schubladenbox') {
                    interieur.drawers.forEach(drawer => {
                        einbautenObject.parts.push(this._createPartsListEntry(interieur, this._getProduktPreis(interieur.product, interieur)));
                        if (drawer.griff) {
                            if (drawer.griff.artikelnummer === 'PushToOpen') {
                                griffeObject.parts.push(this._createGriffEntry(drawer.griff, 'PushToOpen-Schublade'));
                            } else {
                                griffeObject.parts.push(this._createGriffEntry(drawer.griff));
                            }
                        }
                    });
                } else if (interieur.product.type === 'Tuer') {
                    tuerenObject.parts.push(this._createPartsListEntry(interieur, this._getProduktPreis(interieur.product, interieur)));
                    interieur.fluegel.filter(fluegel => fluegel.griff).forEach(fluegel => griffeObject.parts.push(this._createGriffEntry(fluegel.griff, fluegel.griff.griffArtikelnummer)))
                } else if (interieur.product.type === 'Kleiderstange') {
                    const kleiderstangeProduct = APP.findProduct('Kleiderstange');
                    const kleiderstangeEntry = this._createPartsListEntry(interieur, this._getProduktPreis(kleiderstangeProduct, interieur), kleiderstangeProduct);
                    einbautenObject.parts.push(kleiderstangeEntry);
                } else {
                    einbautenObject.parts.push(this._createPartsListEntry(interieur, this._getProduktPreis(interieur.product, interieur)));
                }
            });
            element.konstruktionsboeden.forEach((boden) => {

                einbautenObject.parts.push(this._createPartsListEntry(boden, this._getProduktPreis(boden.product, boden)));
            });
        });

        const addPart = (parts,entry,product,material) => {
            const part = this._createPartsListEntry(entry, this._getProduktPreis(product, entry, material), product);
            parts.push(part);
            return part;
        }

        if (this.arrangement.isSchwebetuer()) {
            const schiene = schrank.schwebetuer.schienen[0];
            addPart(tuerenObject.parts, schiene, APP.findProduct('SchwebeTuerLaufschiene'));
            schrank.schwebetuer.schwebetuerFluegel.forEach((fluegel) => {
                fluegel.fronten.forEach((front, index) => {
                    const frontProduct = (index % 2 === 0)
                        ? front.product
                        : APP.findProduct(
                            'SchwebetuerDekor' + (_.upperFirst(fluegel.streifen) === 'Dekor' ? 'Standard' : _.upperFirst(fluegel.streifen))
                        )
                    addPart(tuerenObject.parts, front, frontProduct);
                });
            });
        }

        if (this.arrangement.isShojituer()) {
            schrank.shojituer.fluegel.forEach((fluegel) => {
                const fluegelPart = {
                    name: 'Türflügel',
                    parts: [],
                };
                tuerenObject.parts.push(fluegelPart);
                const addFluegelPart = (product,vsDataForMaterial) => product && addPart(fluegelPart.parts,fluegel,product,APP.getMaterialForVsData(vsDataForMaterial));
                addFluegelPart(schrank.shojituer.product,fluegel);
                addFluegelPart(_.first(fluegel.papier)?.product,_.first(fluegel.papier));
                addFluegelPart(_.first(fluegel.rahmen)?.product,_.first(fluegel.rahmen));
                // addFluegelPart(_.first(fluegel.griffRahmen)?.product);
                // addFluegelPart(_.first(fluegel.griffPapier)?.product);
                const griffGroup = {
                    name: 'Griff',
                    parts: [],
                };
                addPart(griffGroup.parts,fluegel,APP.findProduct(fluegel.arrangement.griffArtikelnummer));
            });
        }

        if (this.arrangement.schliessdaempfung) {
            const fluegels = this.arrangement.isShojituerAussen() ? schrank.shojituer.fluegel : schrank.schwebetuer.schwebetuerFluegel;
            fluegels.forEach(fluegel => addPart(tuerenObject.parts, fluegel, APP.findProduct('SchliessDaempfung')));
        }

        result.parts.push(_.cloneDeep(einbautenObject));
        result.parts.push(_.cloneDeep(tuerenObject));
        result.parts.push(_.cloneDeep(griffeObject));
        return result;
    }

    addBretterOfSchrank(schrank, result) {
        const schrankPrice = this._getProduktPreis(schrank.product, schrank);
        result = this._createPartsListEntry(schrank, schrankPrice);
        result.parts = [];
        //Elemente
        schrank.elements.forEach((element, index) => {
            const elementPrice = this._getProduktPreis(element.product, element);
            const elementObject = this._createPartsListEntry(element, elementPrice);
            elementObject.elementId = index;
            elementObject.parts = [];
            if (index === 0) {
                const wallLeft = element.wallLeft;
                elementObject.parts.push(this._createPartsListEntry(wallLeft, this._getProduktPreis(wallLeft.product, wallLeft)));
            }
            const wallRight = element.wallRight;
            elementObject.parts.push(this._createPartsListEntry(wallRight, this._getProduktPreis(wallRight.product, wallRight)));
            if (schrank.deckel.needEinzelneDeckel) {
                const elementDeckel = _.filter(schrank.deckel.boeden, (o) => {
                    return o.element === element;
                });
                elementDeckel.forEach(deckel => {
                    elementObject.parts.push(this._createPartsListEntry(deckel, this._getProduktPreis(schrank.deckel.product, deckel), schrank.deckel.product));
                });
            }
            if (!APP.settings.getBool('rueckwand_ist_verbundartikel')) {
                element.rueckwand.forEach(rueckwand => {
                    elementObject.parts.push(this._createPartsListEntry(rueckwand, this._getProduktPreis(rueckwand.product, rueckwand)));
                });
            }
            result.parts.push(_.cloneDeep(elementObject));
        });
        const verbundteileObject = {
            name: 'Verbundteile',
            parts: []
        };
        this.getVerbundArtikel(schrank).forEach(verbundteil => {
            verbundteileObject.parts.push(this._createPartsListEntry(verbundteil, this._getProduktPreis(verbundteil.product, verbundteil)));
        });
        if (!schrank.sockel) {
            const materialArtikelnummer = _.clone(schrank.schrankboden.materialArtikelnummer);
            const sockelBox = schrank.schrankboden.size.clone();
            sockelBox.y = 0;
            sockelBox.z = 0;
            const dummySockel = {
                product: APP.findProduct('Sockel'),
                flaechenMass: sockelBox,
                materialArtikelnummer: materialArtikelnummer,
            };
            verbundteileObject.parts.push(this._createPartsListEntry(dummySockel, this._getProduktPreis(dummySockel.product, dummySockel)));
        }
        result.parts.push(verbundteileObject);
        return result;
    }

    calculateLocalModelPrice() {
        const model = APP.getModel();
        const dims = this._getModelDimensions(model);
        const prod = {
            Dekortyp: 'corpus'
        };
        const priceData = {
            preisDimensionen: dims,
            standard: Preisberechnung.priceToCents(model.PreisStandard),
            materialFaktor: this._getMaterialFactor(prod, APP.getMaterialForVsData(APP.arrangement))
        };
        this._calculatePriceData(priceData);
        return priceData;
    }

    _getProduktPreis(product, config, material=APP.getMaterialForVsData(config)): { preisDimensionen: [], standard: number, materialFaktor: number, preis: number } {
        if (product == null) {
            return {
                preisDimensionen: [],
                standard: 0,
                materialFaktor: 0
            };
        }
        const priceData = {
            preisDimensionen: this._getProductDimensions(product, this._getConfigSize(config)),
            standard: Preisberechnung.priceToCents(product.PreisStandard),
            materialFaktor: this._getMaterialFactor(product, material)
        };
        this._calculatePriceData(priceData);
        return priceData;
    }

    _getConfigSize(config) {
        return v3(config.flaecheMass || config.size || null);
    }

    _getProductDimensions(product, size) {
        const dims = [];
        [["Hoehe", "y"], ["Tiefe", "z"], ["Breite", "x"]].forEach(dim => {
            dims.push({
                name: dim[0],
                ist: size[dim[1]],
                standard: product[dim[0] + 'Standard'],
                faktor: Preisberechnung.priceToCents(product[dim[0] + 'Faktor']),
            })
        });
        return dims;
    }

    _getModelDimensions(model) {
        const dims = this._getProductDimensions(model, this._getConfigSize(this.arrangement.schraenke[0]));
        dims.push({
            name: "Kniestock",
            standard: model['KniestockStandard'],
            faktor: Preisberechnung.priceToCents(model['KniestockFaktor']),
            ist: this.arrangement.schraenke[0].sizeTop.y
        });
        dims.push({
            name: "BreiteOben",
            standard: model['BreiteObenStandard'],
            faktor: Preisberechnung.priceToCents(model['BreiteObenFaktor']),
            ist: this.arrangement.schraenke[0].sizeTop.x
        });
        dims.push({
            name: "AnzahlElemente",
            standard: model['AnzahlElementeStandard'],
            faktor: Preisberechnung.priceToCents(model['AnzahlElementeFaktor']),
            ist: this.arrangement.schraenke[0].elements.length
        });
        dims.push({
            name: "AnzahlSchraegeElemente",
            standard: model['AnzahlSchraegeElementeStandard'],
            faktor: Preisberechnung.priceToCents(model['AnzahlSchraegeElementeFaktor']),
            ist: this.arrangement.schraenke[0].elements.filter(e => e.isSchraeg()).length
        });
        return dims;
    }

    _getMaterialFactor(product, materialArtikelnummer) {
        let prozent = 0;
        const material = APP.findProduct(materialArtikelnummer);
        if (product.Dekortyp != 'ohne' && material) {
            prozent = material.Faktor;
        }
        return 1.0 + prozent / 100.0;
    }

    _calculatePriceData(data) {
        let preis = data.preisDimensionen.reduce((preis, dim) => preis + Math.max(0, dim.ist - dim.standard) * dim.faktor, data.standard);
        data.preis = Math.round(data.materialFaktor * preis);
    }

    getVerbundArtikel(schrank): Array {
        const verbundArtikel = [
            schrank.schrankboden,
        ];
        if (schrank.sockel) {
            verbundArtikel.push(schrank.sockel);
        }
        if (!schrank.deckel.needEinzelneDeckel) {
            verbundArtikel.push(schrank.deckel);
        }
        if (APP.settings.getBool('rueckwand_ist_verbundartikel')) {
            verbundArtikel.push(schrank.rueckwand);
        }
        return verbundArtikel;
    }

    static priceToCents(price) {
        return price * 100;
    }

    static centsToPrice(cents) {
        return Helper.round(cents / 100);
    }

    static getSchrankPreis(schrank) {
        let price = _.get(schrank, 'preis', 0);
        schrank.parts.forEach(part => {
            price += _.get(part, 'preis', 0);
            if (part.parts) {
                part.parts.forEach(child => {
                    price += _.get(child, 'preis', 0);
                });
            }
        });
        return price;
    }

    /*    calcAssemblyPrice(schrank, priceType = 'kunde') {
            if (priceType === 'monteur') {
                return 0;
            } else {
                const schrankPrice = Preisberechnung.getSchrankPreis(schrank);
                const percent = APP.settings.getFloat('montageKostenKunde', 0);
                return Math.max(((schrankPrice / 100) * percent), Preisberechnung.priceToCents(APP.settings.getFloat('montageKostenKundeMin')));
            }
        }*/

}
